import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function resolveImg(url) {
  if (!url) return url;
  return url.startsWith("/") ? `${BACKEND_URL}${url}` : url;
}

export function setAdminToken(token) {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    sessionStorage.setItem("sr_admin_token", token);
  } else {
    delete api.defaults.headers.common.Authorization;
    sessionStorage.removeItem("sr_admin_token");
  }
}

const stored = typeof window !== "undefined" ? sessionStorage.getItem("sr_admin_token") : null;
if (stored) setAdminToken(stored);

export function track(event, meta = {}) {
  api.post("/track", { event, meta }).catch(() => {});
}
